import { AxiosResponse } from "axios";

import { sendRequest } from "../../request/axios";
import { AxiosHttpError } from "../../types/error.type";

export async function generateAdeylaPurchase(trivecCode: number) {
  try {
    await sendRequest<never, AxiosResponse<never>>(
      "get",
      `/users/adelya-item-purchase/?trivec_code=${trivecCode}`
    );
    return { success: true };
  } catch (error) {
    const axiosError = error as AxiosHttpError;
    console.log(error);
    return { success: false, error: axiosError.response?.data };
  }
}
